import { ComponentType } from '@angular/cdk/portal';
import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { ContractService } from 'src/app/contract/shared/contract.service';
import { ClauseComparisionDialogComponent } from '../../clause-comparision-dialog/clause-comparision-dialog.component';
import { ClauseLogDialogComponent } from '../../clause-log-dialog/clause-log-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-contract-clause',
  templateUrl: './contract-clause.component.html',
  styleUrls: ['./contract-clause.component.css']
})
export class ContractClauseComponent implements OnInit, AfterViewInit {
  @Input() contractTypeId;
  @Input() templateId;
  @Input() contractId;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  clausesSource = new MatTableDataSource<any>();
  clausesColumns: string[] = ['Name', 'Version', 'Language', 'Last Updated', 'Action'];
  dataLoading:boolean = false;

  constructor(public contractService: ContractService, private toast: ToastrService, private dialog: MatDialog) {

  }

  ngOnInit() {
    if(this.contractTypeId && this.templateId){
      this.getClauses();
    }
  }

  ngAfterViewInit(): void {
    this.clausesSource.paginator = this.paginator;
    this.clausesSource.sort = this.sort;
  }


  async getClauses() {
    this.dataLoading = true;
    this.clausesSource.data = null;
    try {
      await this.contractService.getContractClauseList(this.contractId).then((res: any) => {
        res.forEach((clause: any) => {
          clause.updatedDate = moment(clause.updatedDate).format('lll');
        });
        this.clausesSource.data = res;
      })
    } catch (error) {
      this.toast.error('Something went wrong! Please try again later.', '');
    }
    this.dataLoading = false;
  }

  async openComparisionDialog(element, mode = 'compare') {
    const selectedComponent: ComponentType<any> = mode === 'compare' ? ClauseComparisionDialogComponent : ClauseLogDialogComponent;
    try {
      await this.contractService.getClauseComparision(element.clauseId, this.contractId).then((res: any) => {
        const dialogRef =
          this.dialog.open(selectedComponent, {
            enterAnimationDuration: '400ms',
            exitAnimationDuration: '500ms',
            minWidth: '25%',
            data: {
              clauseData: res,
            }
          });
      })
    } catch (error) {
      this.toast.error('Something went wrong! Please try again later.', '');
    }
  }

  customSortData(event: Sort) {
    const data = this.clausesSource.data.slice();
    if (!event.active || event.direction === '') {
      this.clausesSource.data = data;
      return;
    }

    this.clausesSource.data = data.sort((a, b) => {
      const valueA = (a[event.active] || '').toString().toLowerCase();
      const valueB = (b[event.active] || '').toString().toLowerCase();

      return this.compare(valueA, valueB, event.direction === 'asc');
    });

    if (this.paginator) {
      this.paginator.firstPage();
    }
  }

  compare(a: string, b: string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}